(function(){
  var rail = document.querySelector('[data-rail]');
  var scrim = document.querySelector('[data-scrim]');
  var openBtn = document.querySelector('[data-rail-open]');
  var closeBtn = document.querySelector('[data-rail-close]');
  function openRail(){ if(rail) rail.classList.add('open'); if(scrim) scrim.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeRail(){ if(rail) rail.classList.remove('open'); if(scrim) scrim.classList.remove('open'); document.body.style.overflow=''; }
  if(openBtn) openBtn.addEventListener('click', openRail);
  if(closeBtn) closeBtn.addEventListener('click', closeRail);
  if(scrim) scrim.addEventListener('click', closeRail);
  window.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeRail(); });
})();
